import axios from "axios";
import serviceHelper from "../../helpers/functions/service.helper";

// ENV Config
const BASE_URL = process.env.REACT_APP_EWALLET_SERVER_URL;
const APP_ID = process.env.REACT_APP_APP_ID;
const SECRET_KEY = process.env.REACT_APP_SECRET_KEY;

/**
 * Generate headers with encoded x-api-token
 */
function getHeaders() {
    const raw = `${APP_ID}|#|${SECRET_KEY}`;
    const encodedToken = btoa(raw); // Browser-safe Base64
    return {
        'x-api-token': encodedToken,
        'Content-Type': 'application/json',
        withCredentials: true,
    };
}

/**
 * Helper for GET requests
 */
async function get(path, query = {}) {
    const queryString = serviceHelper.queryString(query);
    const url = `${BASE_URL}${path}?${queryString}`;
    const headers = getHeaders();
    const response = await axios.get(url, { headers });
    return response?.data;
}

/**
 * Helper for POST requests
 */
async function post(path, body = {}) {
    const url = `${BASE_URL}${path}`;
    const headers = getHeaders();
    const response = await axios.post(url, body, { headers });
    return response?.data;
}

// Exported service functions
async function activity_detail(activity_id,query) {
    return get(`integration/activity/detail/${activity_id}`, query);
}

async function activity_listings(query) {
    return get(`integration/customer_activity_listings`, query);
}

async function transaction_type(query) {
    return get(`integration/activity/transaction_type`, query);
}


export default {
    activity_listings,
    activity_detail,
};
